<div class="modal fade" id="modalCertificacion" tabindex="-1" aria-labelledby="modalCertificacionLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalCertificacionLabel">Certificación</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="form">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Institución</label>
                            <div>
                                <input formControlName="institution" type="text" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('institution')?.invalid && (form.get('institution')?.touched || form.get('institution')?.dirty)}"/>
                                @if (form.get('institution')?.invalid && (form.get('institution')?.touched || form.get('institution')?.dirty)) {
                                    @if (form.get('institution')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('institution')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('institution')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Nombre de la certificación</label>
                            <div>
                                <app-dropdown [options]="certifications" formControlName="certificationId"></app-dropdown>
                                 @if (form.get('certificationId')?.invalid && (form.get('certificationId')?.touched || form.get('certificationId')?.dirty)) {
                                   @if (form.get('certificationId')?.errors?.['required'] == true) {
                                       <div class="invalid-field">
                                           Este campo es requerido
                                       </div>
                                   }
                               }
                           </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Fecha de obtención</label>
                            <div>
                                <input formControlName="completionDate" type="date" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('completionDate')?.invalid && (form.get('completionDate')?.touched || form.get('completionDate')?.dirty)}"/>
                                @if (form.get('completionDate')?.invalid && (form.get('completionDate')?.touched || form.get('completionDate')?.dirty)) {
                                    @if (form.get('completionDate')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Fecha de expiración (si aplica)</label>
                            <div>
                                <input formControlName="expirationDate" type="date" class="form-control" 
                                [ngClass]="{'is-invalid': form.get('expirationDate')?.invalid && (form.get('expirationDate')?.touched || form.get('expirationDate')?.dirty)}"/>
                                @if (form.get('expirationDate')?.invalid && (form.get('expirationDate')?.touched || form.get('expirationDate')?.dirty)) {
                                    @if (form.get('expirationDate')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Descripción de la certificación</label>
                            <div>
                                <textarea  formControlName="description" class="form-control" rows="5"
                                [ngClass]="{'is-invalid': form.get('description')?.invalid && (form.get('description')?.touched || form.get('description')?.dirty)}"></textarea>
                                @if (form.get('description')?.invalid && (form.get('description')?.touched || form.get('description')?.dirty)) {
                                    @if (form.get('description')?.errors?.['required'] == true) {
                                        <div class="invalid-feedback">
                                            Este campo es requerido
                                        </div>
                                    }
                                    @if (form.get('description')?.hasError('maxlength')) {
                                        <div class="invalid-feedback">
                                            Este campo no puede exceder los {{form.get('description')?.errors?.['maxlength']?.requiredLength}} caracteres
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button (click)="submit()" type="button" class="btn btn-primary">
                        @if(!isLoading()){
                            Guardar
                        }@else {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Guardando
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>